import React from "react";
import Slider from "react-slick";

export default function ImageCarousel() {
  const images = [
    "images/0226D309-DF42-48A1-80AD-C31A9E0111DF.jpeg",
    "images/0AE5799B-3642-4976-AA4E-46165CF3DDA0.jpeg",
    "images/0EFB957B-2E82-4233-B42E-314B268B0C6D.jpeg",
    "images/156AC61E-A16F-4E59-9EF9-411FED397367.jpeg",
    "images/1FC36CB1-DCB8-4D2D-ABD6-5E039FE19212.jpeg",
    "images/8A548013-10C6-4273-8528-A2B04A3D1CFE.jpeg",
    "images/AA7D43AF-BCE1-41CE-9B82-B5A151C1537B.jpeg",
    "images/AC3B111A-ED45-4EF2-9396-943375F2FF9C.jpeg",
    "images/alex.jpeg",
    "images/FCF05504-D24A-44DF-86C3-193340E6A030.jpeg",
    "images/IMG_2450.jpeg",
    "images/IMG_2468.jpeg",
    "images/IMG_2470.jpeg",
    "images/IMG_2472.jpeg",
    "images/IMG_3953.jpeg",
    "images/IMG_3965.jpeg",
    "images/IMG_3966.jpeg",
    "images/IMG_6287.jpeg",
    "images/IMG_6288.jpeg",
];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 750,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {images.map((src, i) => (
          <div key={i} className="carousel-slide">
            <img
              src={src}
              alt={`Slide ${i + 1}`}
              className="rounded-2xl shadow-md w-full h-64 object-cover"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
